class CaseInsensitiveMap {
    map = new Map();
    normalizeKey(key) {
        return key.toLowerCase();
    }
    get(key) {
        return this.map.get(this.normalizeKey(key));
    }
    set(key, value) {
        this.map.set(this.normalizeKey(key), value);
    }
    delete(key) {
        this.map.delete(this.normalizeKey(key));
    }
    entries() {
        return this.map.entries();
    }
}
export class SitePagesState {
    pageIdToFolderPath = new Map();
    folderPathToPageId = new CaseInsensitiveMap();
    validatePageIdExists(pageId) {
        if (this.pageIdToFolderPath.has(pageId)) {
            throw new Error(`Duplicated pageId found in structure.xml files: ${pageId}`);
        }
    }
    getAll() {
        const allPages = [];
        for (const [pageId, pagePath] of this.pageIdToFolderPath.entries()) {
            allPages.push({ pageId, pagePath });
        }
        return allPages;
    }
    addPage(pageId, folderPath) {
        this.validatePageIdExists(pageId);
        this.pageIdToFolderPath.set(pageId, folderPath);
        this.folderPathToPageId.set(folderPath, pageId);
    }
    removePageById(pageId) {
        const folderPath = this.pageIdToFolderPath.get(pageId);
        if (folderPath === undefined) {
            return;
        }
        this.pageIdToFolderPath.delete(pageId);
        this.folderPathToPageId.delete(folderPath);
    }
    removePageByPath(path) {
        const pageId = this.folderPathToPageId.get(path);
        if (pageId === undefined) {
            return;
        }
        this.pageIdToFolderPath.delete(pageId);
        this.folderPathToPageId.delete(path);
    }
    getFolderPath(pageId) {
        return this.pageIdToFolderPath.get(pageId);
    }
    getPageId(folderPath) {
        return this.folderPathToPageId.get(folderPath);
    }
}
